<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>抽奖活动</span>
        <el-button type="primary" @click="handleGoDraw">去发布抽奖活动</el-button>
    </div>
    <el-collapse accordion>
        <el-collapse-item title="抽奖活动有什么作用?" name="1">
            <p>通过设置抽奖规则，助力项目在站内、站外快速传播，促进用户评论互动，提升项目曝光量。同时，在筹资达标时，还可用于回馈客户 。</p>
        </el-collapse-item>
        <el-collapse-item title="抽奖活动的流程是什么?" name="2">
            <el-image 
                class="pc-image"
                style="margin: 15px 0 0 0;"
                :src="drawStep"
                :preview-src-list="imageList"
                :initial-index="0"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
        </el-collapse-item>
        <el-collapse-item title="抽奖活动方式有哪些？" name="3">
            <p>项目众筹中，建议每周更新1次；项目众筹完成，建议每月发布2次；</p>
            <ul class="circle">
                <li>
                    <strong>无支付门槛抽奖</strong>
                    <p>所有人都可以参与，完成1个任务积累1个抽奖码，完成任务越多，中奖概率越大；</p>
                </li>
                <li>
                    <strong>有支付门槛抽奖</strong>
                    <p>购买指定回报档才可以参与抽奖，完成1个任务积累1个抽奖码，完成任务越多，中奖概率越大；（设置路径：发起抽奖—更多功能—关联回报档）</p>
                </li>
            </ul>
        </el-collapse-item>
        <el-collapse-item title="奖品类型可以设置哪些？" name="4">
            <ul class="circle">
                <li>
                    <strong>奖品</strong>
                    <p>实物奖品、虚拟奖品（如返现券，半价券等）</p>
                </li>
                <li>
                    <strong>购买权</strong>
                    <p>用于抽取购买资格；仅向中奖用户开放购买权，一般针对限量商品</p>
                </li>
            </ul>
        </el-collapse-item>
        <el-collapse-item title="如何设置抽奖活动？" name="5">
            <p style="font-weight: 600;">1.电脑端「项目管理后台」—「抽奖&种草」—「创建抽奖」；</p>
            <el-image 
                class="enlarged pc-image"
                :src="draw1"
                :preview-src-list="imageList"
                :initial-index="1"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;font-weight: 600;">2.添加抽奖活动标题，选择该抽奖活动关联的众筹项目；</p>
            <el-image 
                class="enlarged pc-image"
                :src="draw2"
                :preview-src-list="imageList"
                :initial-index="2"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;font-weight: 600;">3.添加奖励类型：奖品/购买权/活动审核</p>
            <ul class="circle">
                <li>
                    <strong>奖励类型：奖品</strong>
                    <p>点击「添加奖品」，选择或者上传奖品并保存，奖品可以是虚拟产品也可以是实物产品；</p>
                    <el-image 
                        class="enlarged pc-image"
                        :src="draw3"
                        :preview-src-list="imageList"
                        :initial-index="3"
                        :preview-teleported="true"
                        fit="contain"
                        loading="lazy"
                    />
                </li>
                <li>
                    <strong>奖励类型：购买权（用于抽取购买资格）</strong>
                    <p>奖励类型选择「购买权」，点击「添加商品」选择回报档，并确定，设置活动开始、结束时间；</p>
                    <el-image 
                        class="enlarged pc-image"
                        :src="draw4"
                        :preview-src-list="imageList"
                        :initial-index="4"
                        :preview-teleported="true"
                        fit="contain"
                        loading="lazy"
                    />
                </li>
            </ul>
            <p style="padding: 60px 0 0 0;font-weight: 600;">4.设置抽奖规则、开奖时间等信息，保存并发布，抽奖活动就设置好啦</p>
            <el-image 
                class="enlarged pc-image"
                :src="draw5"
                :preview-src-list="imageList"
                :initial-index="5"
                :preview-teleported="true"
                fit="contain"
                loading="lazy"
            />
            <p style="padding: 60px 0 0 0;font-weight: 600;">5.更多功能</p>
            <ul class="circle">
                <li>
                    <strong>关联回报档</strong>
                    <p>可作为抽奖活动门槛，用户需购买关联回报档（回报档可多选），方可参与抽奖</p>
                </li>
                <li>
                    <strong>关联活动</strong>
                    <p>活动指小红书活动，是2个活动的联动玩法</p>
                    <p>支付前：用户可随时参与抽奖，中奖后需完成小红书活动任务方可领取奖品；</p>
                    <p>参与抽奖前：用户完成小红书活动任务后，才可以参加本次抽奖；</p>
                </li>
                <li>
                    <strong>开启掉落</strong>
                    <p>若中奖用户未领取奖品，启用掉落机制后，在参与抽奖用户群中重新开奖；掉落次数=重新开奖次数，直至奖品被领取；</p>
                    <el-image 
                        class="enlarged pc-image"
                        :src="draw6"
                        :preview-src-list="imageList"
                        :initial-index="6"
                        :preview-teleported="true"
                        fit="contain"
                        loading="lazy"
                    />
                </li>
            </ul>
        </el-collapse-item>
        <el-collapse-item title="在哪里能看到抽奖活动？" name="6">
            <div class="tab_tips">
                <div class="item">
                    <p>在app中个人中心页面入口</p>
                    <el-image 
                        class="enlarged"
                        :src="drawApp1"
                        :preview-src-list="imageList"
                        :initial-index="7"
                        :preview-teleported="true"
                        fit="contain"
                        loading="lazy"
                    />
                </div>
                <div class="item">
                    <p>众筹项目详情页入口</p>
                    <el-image 
                        class="enlarged"
                        :src="drawApp2"
                        :preview-src-list="imageList"
                        :preview-teleported="true"
                        :initial-index="8"
                        fit="contain"
                        loading="lazy"
                    />
                </div>
            </div>
            <el-button style="margin: 20px 0 0 0;" type="primary" @click="handleGoDraw">去发布抽奖活动</el-button>
        </el-collapse-item>
    </el-collapse>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const drawStep = `${CDN_BASE}draw_step.png`
const draw1 = `${CDN_BASE}draw_1.png`
const draw2 = `${CDN_BASE}draw_2.png`
const draw3 = `${CDN_BASE}draw_3.png`
const draw4 = `${CDN_BASE}draw_4.png`
const draw5 = `${CDN_BASE}draw_5.png`
const draw6 = `${CDN_BASE}draw_6.png`
const drawApp1 = `${CDN_BASE}draw_app_1.png`
const drawApp2 = `${CDN_BASE}draw_app_2.png`

// 图片列表，用于预览
const imageList = [drawStep, draw1, draw2, draw3, draw4, draw5, draw6, drawApp1, drawApp2]
const router = useRouter()
const handleGoDraw = () => {
    router.push((`/operate_manage/drawtool/initiate`))
}
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    margin: 0 0 40px 0;
    position: relative;
    .el-button{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.el-collapse{
    border:none;
    ::v-deep(.el-collapse-item){
        padding: 0 0 40px 0;
    }
    ::v-deep(.el-collapse-item__wrap){
        border:none;
        .el-collapse-item__content{
            padding: 0;
        }
    }
    ::v-deep(.el-collapse-item__header){    
        border:none;
        font-size: 24px;
        color: #1A1A1A;
        font-weight: 600;
        line-height: 24px;
    }
}
.el-collapse{
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    .tab_title{
        font-weight: 600;
    }
    .tab_tips{
        display: flex;
        align-items: center;
        margin: 10px 0 0 0;
        .item{
            width: 200px;
            margin: 0 30px 0 0;
            p{
                font-weight: 600;
                font-size: 14px;
                line-height: 1;
                margin: 0 0 30px 0;
            }
            .el-image {
                width: 100%;
                height: auto;
                cursor: pointer;
                
                &.enlarged {
                    transform: scale(1.2);
                    transform-origin: center;
                    transition: transform 0.3s ease;
                }
            }
        }
    }
    p{
        font-size: 14px;
        line-height: 21px;
        span{
            font-weight: 600;
        }
    }
    img{
        width: 100%;
        height: auto;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 230px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
            strong{
                line-height: 1;
                display: block;
                padding: 20px 0 10px 0;
                font-weight: 600;
            }
        }
        
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>